import * as helpers from '../../js/helpers';

export default function mapArea() {
    const map = document.querySelector('.location');

    if (!map) {
        return;
    }

    const mapWrapper = map.querySelector('.location__map');
    const links = Array.prototype.slice.call(map.querySelectorAll('.location__map-region'));
    const listItems = Array.prototype.slice.call(map.querySelectorAll('.location__list-link'));
    const tooltipMap = map.querySelector('.tooltip-map');

    const getFocusOffset = (el, e) => {
        const elRect = el.getBoundingClientRect();
        const targetRect = e.target.getBoundingClientRect();
        return {
            top: targetRect.top - elRect.top + (targetRect.bottom - targetRect.top) / 2,
            left: targetRect.left - elRect.left + (targetRect.right - targetRect.left) / 2,
        };
    };

    const getMouseOffset = (el, e) => {
        const rect = el.getBoundingClientRect();

        return {
            top: e.pageY - (rect.top + (window.scrollY || window.pageYOffset)),
            left: e.pageX - (rect.left + (window.scrollX || window.pageXOffset)),
        };
    };


    const updatePosition = (e) => {
        let coords;

        if (e.type === 'focus') {
            coords = getFocusOffset(mapWrapper, e);
        } else {
            coords = getMouseOffset(mapWrapper, e);
        }

        const x = coords.left;
        const y = coords.top;

        tooltipMap.style.top = `${Math.floor(y) - 25}px`;
        tooltipMap.style.left = `${Math.floor(x)}px`;
    };

    const tooltipOn = (e, link = false) => {
        const item = link || e.target;
        const path = item.querySelector('path');

        if (path) {
            tooltipMap.innerHTML = path.getAttribute('aria-label');
            updatePosition(e);
        }
    };

    const unsetActiveElements = (zones = links) => zones.forEach(link => link.removeAttribute('data-active'));

    links.forEach((link) => {
        link.addEventListener('mousemove', helpers.debounce(updatePosition, 10));
        link.addEventListener('mouseenter', (e) => {
            const id = e.target.getAttribute('data-area-id');
            const activeLocationLink = map.querySelector(`.location__list-link[data-area-id="${id}"]`);

            activeLocationLink.setAttribute('data-active', true);

            tooltipMap.style.display = 'block';
            tooltipOn(e);
        });
        link.addEventListener('mouseleave', () => {
            tooltipMap.style.display = 'none';

            unsetActiveElements(listItems);
        });
        link.addEventListener('focus', (e) => {
            helpers.addClass(map, 'focus');
            tooltipMap.style.display = 'block';
            tooltipOn(e);
        });
        link.addEventListener('blur', () => {
            helpers.removeClass(map, 'focus');
            tooltipMap.style.display = 'none';
        });
    });

    listItems.forEach((item) => {
        ['mouseenter', 'focus'].forEach((eventType) => {
            item.addEventListener(eventType, (e) => {
                const id = e.target.getAttribute('data-area-id');
                const link = map.querySelector(`.location__map-region[data-area-id="${id}"]`);

                link.setAttribute('data-active', true);
            });
        });

        ['mouseleave', 'blur'].forEach((eventType) => {
            item.addEventListener(eventType, (e) => {
                tooltipMap.style.display = 'none';
                unsetActiveElements();
            });
        });
    });
}
